<div
  *ngIf="node"
  [ngClass]="
    isRootLayout
      ? 'tw-flex tw-flex-col tw-gap-4 lg:tw-grid lg:tw-grid-cols-[200px_minmax(0,1fr)] lg:tw-items-start lg:tw-gap-6'
      : 'tw-block'
  "
>
  <nav
    *ngIf="isRootLayout && sections.length > 1"
    class="tw-flex tw-flex-col tw-gap-2 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-p-3 lg:tw-sticky lg:tw-top-[132px] lg:tw-max-h-[calc(100vh-148px)] lg:tw-overflow-auto"
    aria-label="Settings sections"
  >
    <p class="tw-m-0 tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-wide tw-text-slate-400">Jump to</p>
    <div class="tw-flex tw-flex-wrap tw-gap-1.5 lg:tw-flex-col lg:tw-flex-nowrap">
      <button
        type="button"
        class="tw-cursor-pointer tw-rounded-lg tw-border tw-px-2.5 tw-py-2 tw-text-left tw-text-xs tw-font-semibold hover:tw-bg-blue-50 hover:tw-text-blue-600"
        *ngFor="let section of sections; trackBy: trackSection"
        [ngClass]="openSectionId === section.id ? 'tw-border-blue-200 tw-bg-blue-50 tw-text-blue-700' : 'tw-border-transparent tw-bg-slate-50 tw-text-slate-600'"
        (click)="jumpToSection(section.id)"
      >
        {{ section.title || section.id }}
      </button>
    </div>
  </nav>

  <div class="tw-min-w-0">
    <div class="tw-flex tw-flex-col" [ngClass]="isRootLayout ? 'tw-gap-0' : 'tw-gap-3'">
      <section
        *ngFor="let section of sections; trackBy: trackSection"
        [attr.data-section]="section.id"
        [ngClass]="
          isRootLayout
            ? 'tw-flex tw-min-w-0 tw-flex-col tw-overflow-hidden tw-rounded-xl tw-border tw-bg-white ' +
              (isAccordionOpen(section.id) ? 'tw-border-slate-300' : 'tw-border-slate-200')
            : 'tw-flex tw-min-w-0 tw-flex-col tw-overflow-visible tw-border-0 tw-bg-transparent'
        "
        [hidden]="isRootLayout && !isAccordionOpen(section.id)"
      >
        <div *ngIf="isRootLayout && section.title" class="tw-flex tw-items-center tw-justify-between tw-gap-3 tw-border-b tw-border-slate-200 tw-bg-slate-50 tw-px-4 tw-py-3.5">
          <h3 class="tw-m-0 tw-text-[15px] tw-font-bold tw-text-slate-900">{{ section.title }}</h3>
          <span class="tw-text-[11px] tw-font-semibold tw-text-slate-400">{{ section.keys.length }} fields</span>
        </div>
        <p *ngIf="isAccordionOpen(section.id) && section.note" class="tw-mx-4 tw-mb-0 tw-mt-3 tw-rounded-[10px] tw-bg-blue-50 tw-px-3 tw-py-2.5 tw-text-[13px] tw-font-semibold tw-leading-snug tw-text-blue-700">
          {{ section.note }}
        </p>
        <h3 *ngIf="!isRootLayout && section.title" class="tw-m-0 tw-px-3.5 tw-pt-3 tw-text-[15px] tw-font-bold tw-tracking-tight tw-text-slate-900">{{ section.title }}</h3>

        <div
          *ngIf="isAccordionOpen(section.id)"
          [ngClass]="isRootLayout ? 'tw-grid tw-grid-cols-1 tw-gap-3 tw-p-3.5 min-[900px]:tw-grid-cols-2' : 'tw-flex tw-flex-col tw-gap-3 tw-p-0'"
        >
          <div
            *ngFor="let key of section.keys; trackBy: trackKey"
            class="tw-min-w-0"
            [ngClass]="
              (shouldHoistObject(key, section) ? 'tw-col-span-full tw-flex tw-flex-col tw-gap-3 ' : '') +
              (leafKind(key, node[key]) === 'html' ? 'tw-col-span-full ' : '') +
              (isRootLayout && isPlainObject(node[key]) ? 'min-[900px]:tw-col-span-full' : '')
            "
          >
            <ng-container *ngIf="isPlainObject(node[key]) && depth < maxDepth; else leafOnly">
              <ng-container *ngIf="shouldHoistObject(key, section); else objectCard">
                <div *ngIf="gateKeyFor(key)" class="tw-flex tw-items-center tw-gap-2.5">
                  <label class="tw-inline-flex tw-cursor-pointer tw-select-none tw-items-center tw-gap-2.5">
                    <input type="checkbox" class="tw-peer tw-sr-only" [checked]="asObjectGate(key)" (change)="setObjectGate(key, $any($event.target).checked)" />
                    <span
                      class="tw-relative tw-h-6 tw-w-11 tw-shrink-0 tw-rounded-full tw-bg-slate-300 tw-transition-colors after:tw-absolute after:tw-left-[3px] after:tw-top-[3px] after:tw-h-[18px] after:tw-w-[18px] after:tw-rounded-full after:tw-bg-white after:tw-shadow-sm after:tw-transition-transform after:tw-content-[''] peer-checked:tw-bg-blue-600 peer-checked:after:tw-translate-x-5"
                    ></span>
                    <span class="tw-text-[13px] tw-font-semibold tw-text-slate-600">{{ asObjectGate(key) ? 'On' : 'Off' }}</span>
                  </label>
                </div>
                <ngx-options-tree-editor
                  *ngIf="isSectionExpanded(key)"
                  [node]="objectChild(key)"
                  [pathPrefix]="pathFor(key)"
                  [defaults]="objectDefaults(key)"
                  [hideKeys]="gateKeysToHide(key)"
                  [scope]="scope"
                  [depth]="depth + 1"
                  (unsetPath)="onChildUnset($event)"
                  (restorePath)="onChildRestore($event)"
                >
                </ngx-options-tree-editor>
                <p *ngIf="!isSectionExpanded(key)" class="tw-mb-0 tw-mt-1 tw-text-xs tw-text-slate-400">Turn on to edit this section’s settings.</p>
              </ng-container>

              <ng-template #objectCard>
                <fieldset class="tw-m-0 tw-min-w-0 tw-rounded-xl tw-border tw-border-slate-200 tw-p-4" [ngClass]="isSectionExpanded(key) ? 'tw-bg-slate-50' : 'tw-bg-white tw-pb-3'">
                  <legend class="tw-inline-flex tw-items-center tw-gap-2.5 tw-px-1.5 tw-text-[13px] tw-font-bold tw-text-slate-900">
                    <span>{{ labelFor(key) }}</span>
                    <label *ngIf="gateKeyFor(key)" class="tw-inline-flex tw-cursor-pointer tw-select-none tw-items-center tw-gap-2.5" (click)="$event.stopPropagation()">
                      <input type="checkbox" class="tw-peer tw-sr-only" [checked]="asObjectGate(key)" (change)="setObjectGate(key, $any($event.target).checked)" />
                      <span
                        class="tw-relative tw-h-6 tw-w-11 tw-shrink-0 tw-rounded-full tw-bg-slate-300 tw-transition-colors after:tw-absolute after:tw-left-[3px] after:tw-top-[3px] after:tw-h-[18px] after:tw-w-[18px] after:tw-rounded-full after:tw-bg-white after:tw-shadow-sm after:tw-transition-transform after:tw-content-[''] peer-checked:tw-bg-blue-600 peer-checked:after:tw-translate-x-5"
                      ></span>
                      <span class="tw-text-[13px] tw-font-semibold tw-text-slate-600">{{ asObjectGate(key) ? 'On' : 'Off' }}</span>
                    </label>
                    <button type="button" class="tw-cursor-pointer tw-border-0 tw-bg-transparent tw-px-1 tw-py-0.5 tw-text-xs tw-font-semibold tw-text-slate-500 hover:tw-text-red-500 hover:tw-underline" title="Exclude this group — you can add it back in this section" (click)="excludeKey(key)">
                      Exclude
                    </button>
                  </legend>

                  <ngx-options-tree-editor
                    *ngIf="isSectionExpanded(key)"
                    [node]="objectChild(key)"
                    [pathPrefix]="pathFor(key)"
                    [defaults]="objectDefaults(key)"
                    [hideKeys]="gateKeysToHide(key)"
                    [scope]="scope"
                    [depth]="depth + 1"
                    (unsetPath)="onChildUnset($event)"
                    (restorePath)="onChildRestore($event)"
                  >
                  </ngx-options-tree-editor>

                  <p *ngIf="!isSectionExpanded(key)" class="tw-mb-0 tw-mt-1 tw-text-xs tw-text-slate-400">Turn on to edit this section’s settings.</p>
                </fieldset>
              </ng-template>
            </ng-container>

            <ng-template #leafOnly>
              <div *ngIf="isPlainObject(node[key]) && depth >= maxDepth" class="tw-flex tw-flex-col tw-gap-2 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-px-4 tw-py-3.5">
                <div class="tw-flex tw-items-center tw-justify-between tw-gap-3">
                  <label class="tw-text-[13px] tw-font-semibold tw-text-slate-700">{{ labelFor(key) }}</label>
                  <button type="button" class="tw-cursor-pointer tw-border-0 tw-bg-transparent tw-px-1 tw-py-0.5 tw-text-xs tw-font-semibold tw-text-slate-500 hover:tw-text-red-500 hover:tw-underline" (click)="excludeKey(key)">Exclude</button>
                </div>
                <p class="tw-m-0 tw-w-full tw-text-[11px] tw-text-slate-400">Nested object is too deep to edit here.</p>
              </div>

              <div *ngIf="!isPlainObject(node[key])" class="tw-flex tw-flex-col tw-gap-2 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-px-4 tw-py-3.5" [attr.data-kind]="leafKind(key, node[key])">
                <div class="tw-flex tw-items-center tw-justify-between tw-gap-3">
                  <label class="tw-text-[13px] tw-font-semibold tw-text-slate-700" [attr.for]="pathFor(key)">{{ labelFor(key) }}</label>
                  <button type="button" class="tw-cursor-pointer tw-border-0 tw-bg-transparent tw-px-1 tw-py-0.5 tw-text-xs tw-font-semibold tw-text-slate-500 hover:tw-text-red-500 hover:tw-underline" title="Exclude this setting — you can add it back in this section" (click)="excludeKey(key)">
                    Exclude
                  </button>
                </div>

                <ng-container [ngSwitch]="leafKind(key, node[key])">
                  <div class="tw-flex tw-w-full tw-min-w-0 tw-flex-wrap tw-items-center tw-gap-2.5" *ngSwitchCase="'boolean'">
                    <label class="tw-inline-flex tw-cursor-pointer tw-select-none tw-items-center tw-gap-2.5">
                      <input type="checkbox" class="tw-peer tw-sr-only" [id]="pathFor(key)" [checked]="asBoolean(key)" (change)="setBoolean(key, $any($event.target).checked)" />
                      <span
                        class="tw-relative tw-h-6 tw-w-11 tw-shrink-0 tw-rounded-full tw-bg-slate-300 tw-transition-colors after:tw-absolute after:tw-left-[3px] after:tw-top-[3px] after:tw-h-[18px] after:tw-w-[18px] after:tw-rounded-full after:tw-bg-white after:tw-shadow-sm after:tw-transition-transform after:tw-content-[''] peer-checked:tw-bg-blue-600 peer-checked:after:tw-translate-x-5"
                      ></span>
                      <span class="tw-text-[13px] tw-font-semibold tw-text-slate-600">{{ asBoolean(key) ? 'On' : 'Off' }}</span>
                    </label>
                  </div>

                  <div class="tw-flex tw-w-full tw-min-w-0 tw-flex-nowrap tw-items-center tw-gap-2.5" *ngSwitchCase="'color'">
                    <input
                      type="color"
                      class="tw-h-10 tw-w-11 tw-shrink-0 tw-cursor-pointer tw-rounded-[10px] tw-border-2 tw-border-slate-200 tw-bg-transparent tw-p-0"
                      [ngModel]="colorPickerValue(key)"
                      (ngModelChange)="setColor(key, $event)"
                      [name]="pathFor(key) + '-swatch'"
                    />
                    <input
                      type="text"
                      class="tw-min-w-0 tw-flex-1 tw-rounded-[10px] tw-border-2 tw-border-slate-200 tw-px-3 tw-py-2.5 tw-text-sm tw-text-slate-900 tw-outline-none focus:tw-border-blue-600"
                      [id]="pathFor(key)"
                      [ngModel]="asString(key)"
                      (ngModelChange)="setNullableString(key, $event)"
                      [name]="pathFor(key)"
                      placeholder="#2E3138"
                    />
                  </div>

                  <div class="tw-flex tw-w-full tw-min-w-0 tw-flex-wrap tw-items-center tw-gap-2.5" *ngSwitchCase="'number'">
                    <input
                      type="number"
                      class="tw-w-full tw-min-w-0 tw-flex-1 tw-rounded-[10px] tw-border-2 tw-border-slate-200 tw-px-3 tw-py-2.5 tw-text-sm tw-text-slate-900 tw-outline-none focus:tw-border-blue-600"
                      [id]="pathFor(key)"
                      [ngModel]="asNumber(key)"
                      (ngModelChange)="setNumber(key, $event)"
                      [name]="pathFor(key)"
                    />
                  </div>

                  <div class="tw-flex tw-w-full tw-min-w-0 tw-flex-wrap tw-items-center tw-gap-2.5" *ngSwitchCase="'url'">
                    <input
                      type="url"
                      class="tw-w-full tw-min-w-0 tw-flex-1 tw-rounded-[10px] tw-border-2 tw-px-3 tw-py-2.5 tw-text-sm tw-text-slate-900 tw-outline-none focus:tw-border-blue-600"
                      [ngClass]="urlError(key) ? 'tw-border-red-500' : 'tw-border-slate-200'"
                      [id]="pathFor(key)"
                      [ngModel]="asString(key)"
                      (ngModelChange)="setUrl(key, $event)"
                      [name]="pathFor(key)"
                      placeholder="https://example.com/..."
                    />
                    <span class="tw-w-full tw-text-[11px] tw-font-semibold tw-text-red-500" *ngIf="urlError(key) as err">{{ err }}</span>
                    <span class="tw-w-full tw-text-[11px] tw-text-slate-400" *ngIf="!urlError(key)">Must be http:// or https:// URL</span>
                  </div>

                  <div class="tw-flex tw-w-full tw-min-w-0 tw-flex-col tw-items-stretch tw-gap-2.5" *ngSwitchCase="'html'">
                    <textarea
                      class="tw-min-h-24 tw-w-full tw-resize-y tw-rounded-[10px] tw-border-2 tw-border-slate-200 tw-px-3 tw-py-2.5 tw-font-mono tw-text-xs tw-leading-snug tw-outline-none focus:tw-border-blue-600"
                      [id]="pathFor(key)"
                      [ngModel]="asString(key)"
                      (ngModelChange)="setNullableString(key, $event)"
                      [name]="pathFor(key)"
                      spellcheck="false"
                      rows="6"
                      placeholder="<p>Message</p>"
                    ></textarea>
                    <span class="tw-w-full tw-text-[11px] tw-text-slate-400">HTML. The preview below is how it will look.</span>
                    <div class="tw-w-full tw-rounded-[10px] tw-border tw-border-dashed tw-border-slate-300 tw-bg-white tw-p-3 tw-text-sm tw-leading-normal tw-text-slate-900" *ngIf="asString(key)" [innerHTML]="asString(key)"></div>
                  </div>

                  <div class="tw-flex tw-w-full tw-min-w-0 tw-flex-wrap tw-items-center tw-gap-2.5" *ngSwitchCase="'array'">
                    <textarea
                      class="tw-min-h-24 tw-w-full tw-resize-y tw-rounded-[10px] tw-border-2 tw-border-slate-200 tw-px-3 tw-py-2.5 tw-font-mono tw-text-xs tw-leading-snug tw-outline-none focus:tw-border-blue-600"
                      [id]="pathFor(key)"
                      [value]="arrayText(key)"
                      (blur)="onArrayBlur(key, $event)"
                      [name]="pathFor(key)"
                      spellcheck="false"
                      rows="4"
                    ></textarea>
                    <span class="tw-w-full tw-text-[11px] tw-text-slate-400">List value — edit as JSON array, then click away to apply</span>
                  </div>

                  <div class="tw-flex tw-w-full tw-min-w-0 tw-flex-wrap tw-items-center tw-gap-2.5" *ngSwitchDefault>
                    <input
                      type="text"
                      class="tw-w-full tw-min-w-0 tw-flex-1 tw-rounded-[10px] tw-border-2 tw-border-slate-200 tw-px-3 tw-py-2.5 tw-text-sm tw-text-slate-900 tw-outline-none focus:tw-border-blue-600"
                      [id]="pathFor(key)"
                      [ngModel]="asString(key)"
                      (ngModelChange)="setNullableString(key, $event)"
                      [name]="pathFor(key)"
                      placeholder="Empty — type a value"
                    />
                  </div>
                </ng-container>
              </div>
            </ng-template>
          </div>

          <div *ngIf="section.missingKeys.length" class="tw-col-span-full tw-flex tw-flex-col tw-gap-2.5 tw-rounded-[10px] tw-border tw-border-dashed tw-border-slate-300 tw-bg-white tw-px-3.5 tw-py-3">
            <p class="tw-m-0 tw-text-xs tw-font-bold tw-uppercase tw-tracking-wide tw-text-slate-500">Add to this section</p>
            <div class="tw-flex tw-flex-wrap tw-gap-2">
              <button
                type="button"
                class="tw-cursor-pointer tw-rounded-full tw-border tw-border-slate-300 tw-bg-slate-50 tw-px-3 tw-py-1.5 tw-text-xs tw-font-semibold tw-text-blue-600 hover:tw-border-blue-600 hover:tw-bg-blue-50"
                *ngFor="let key of section.missingKeys; trackBy: trackKey"
                (click)="addKey(key)"
              >
                + {{ labelFor(key) }}
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
